import Template from './Template';

export default function Error() {
  return (
    <Template title="Error">
      <h1>This is the Error Page</h1>
    </Template>
  );
}
